import React, { Component, Fragment } from 'react';
import moment from 'moment';

import ModalEscalarTitularidad from './ModalEscalarTitularidad.js';
import Modal from "./Modal.js";
import ParadigmaTable from "../../components/ParadigmaTable/ParadigmaTable.js";
import DateFilter from "../../components/ParadigmaTable/DateFilter";
import NumericFilter from "../../components/ParadigmaTable/NumericFilter";
import { format } from '../../functions/functions';

import api from "../../api/api.js";

class Ventas extends Component {
    constructor(props) {
        super(props);
        this.state = {
            columns: [
                {
                    Header: "id",
                    id: "id",
                    accessor: "id",
                    width: 100,
                    show: false,
                    private: true,
                },
                {
                    Header: "Fecha",
                    id: "fecha",
                    accessor: d => moment(d.fecha).format('DD/MM/YYYY'),
                    className: "text-center",
                    show: true,
                    width: 100,
                    Filter: ({ filter, onChange }) => <DateFilter filter={filter} onChange={onChange} datetime />
                },
                {
                    Header: "Comprador/es",
                    id: "clientes",
                    accessor: d => d.clientes,
                    show: true,
                },
                {
                    Header: "Vendedor",
                    id: "vendedor_nombre",
                    accessor: "vendedor_nombre",
                    show: true,
                },
                {
                    Header: "Loteo",
                    id: "loteo",
                    lookup: "nombre__icontains",
                    accessor: d => d.loteo.nombre,
                    filterable: (!localStorage.permisos.includes("loteos_larufinaii") || localStorage.permisos.includes("superadmin")),
                    show: true,
                },
                {
                    Header: "Lote",
                    id: "lote_nombre",
                    accessor: "lote_nombre",
                    show: true,
                },
                {
                    Header: "Estado",
                    id: "estado",
                    accessor: "estado",
                    show: true,
                    className: "text-center",
                    width: 120,
                    Filter: ({ filter, onChange }) =>
                        <select
                            value={filter ? filter.value : ''}
                            onChange={e => onChange(e.target.value)}
                        >
                            <option value="">Todos</option>
                            <option value="P">Pendiente</option>
                            <option value="F">Firmada</option>
                            <option value="R">Rescindida</option>
                        </select>,
                    accessor: d =>
                        <Fragment>
                            { d.estado !== null &&
                                <div
                                    className={'ui-status-pill ' + (d.estado === "F" ? 'is-success' : (d.estado === 'R') ? 'is-danger' : 'is-warning')}
                                >
                                    {(d.estado === "F") ? 'Firmada' : (d.estado === 'R') ? 'Rescindida' : 'Pendiente'}
                                </div>
                            }
                        </Fragment>,
                },
                {
                    Header: "Saldado",
                    id: "saldado",
                    className: 'text-center',
                    show: true,
                    width: 120,
                    accessor: d =>
                        d.estado === 'F' &&
                        <div
                            className={'ui-status-pill ' + (d.saldado ? 'is-success' : 'is-warning')}
                        >
                            {d.saldado ? 'Saldado' : 'Por saldar'}
                        </div>,
                    Filter: ({ filter, onChange }) =>
                        <select
                            value={filter ? filter.value : ''}
                            onChange={e => onChange(e.target.value)}
                        >
                            <option value="">Todos</option>
                            <option value="true">Saldado</option>
                            <option value="false">Por saldar</option>
                        </select>,
                },
                {
                    Header: "Moneda",
                    id: "moneda",
                    accessor: "moneda",
                    show: false,
                    private: true,
                },
                {
                    Header: "Monto",
                    id: "monto_total_cuotas",
                    accessor: d => `${d.moneda.simbolo} ${format(d.monto_total_cuotas)}`,
                    className: 'text-right',
                    show: true,
                    Filter: ({ filter, onChange }) => <NumericFilter filter={filter} onChange={onChange} />
                },
            ]
        };
    }

    render() {
        const outerFilter = (localStorage.permisos.includes("loteos_larufinaii") && !localStorage.permisos.includes("superadmin")) ? [
            {
                id: 'loteo',
                value: 'LA RUFINA II'
            }
        ] : [];

        return (
            <ParadigmaTable
                buttons={[
                    {
                        create: true,
                        component: props => <Modal {...props} action="CREATE" />,
                        permission: 'ventas_ventas_new',
                    },
                    {
                        edit: true,
                        component: props => <Modal {...props} action="EDIT" />,
                        permission: 'ventas_ventas_edit',
                    },
                    {
                        detail: true,
                        component: props => <Modal {...props} action="DETAIL" />,
                        permission: 'ventas_ventas_detail',
                    },
                    {
                        edit: true,
                        component: props => <Modal {...props} action="FIRMAR" />,
                        permission: 'ventas_ventas_firmar',
                    },
                    {
                        edit: true,
                        component: props => <Modal {...props} action="RESCINDIR" />,
                        permission: 'ventas_ventas_firmar',
                    },
                    {
                        edit: true,
                        component: props => <Modal {...props} action="DELETE" />,
                        permission: 'ventas_ventas_delete',
                    },
                    {
                        edit: true,
                        component: props => <Modal {...props} action="CUOTAS" activeTab={2} />,
                        permission: 'ventas_ventas_view',
                    },
                    {
                        edit: true,
                        component: props => <ModalEscalarTitularidad {...props} />,
                        permission: 'ventas_ventas_view',
                    }
                ]}
                depth={2}
                apiUrl={api.ventas.ventas}
                columns={this.state.columns}
                exportUrl={api.ventas.ventas}
                outerFilter={outerFilter}
                title={"Ventas"}
            />
        );
    }
}

export default Ventas;



// WEBPACK FOOTER //
// ./src/views/Ventas/Ventas.js